import { render, staticRenderFns } from "./PopupTermCondition.vue?vue&type=template&id=5bd1d728&scoped=true"
import script from "./PopupTermCondition.vue?vue&type=script&lang=js"
export * from "./PopupTermCondition.vue?vue&type=script&lang=js"
import style0 from "./PopupTermCondition.vue?vue&type=style&index=0&id=5bd1d728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd1d728",
  null
  
)

export default component.exports